import React from 'react';
import { Router as OldRouter } from 'react-router-dom';
// import createBrowserHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from 'history';
import engine from 'store/src/store-engine';
import sessionStorages from 'store/storages/sessionStorage';
import plugins from 'store/plugins/expire';
import wrapReact from '../react';
import { routes } from '../../config/routes';
import { Routes } from './routes';
import { getCiamRedirectUriForLogout, getCiamClientId, getCiamDomain } from '../url';

const customHistory = createBrowserHistory();
const sessionStore = engine.createStore(sessionStorages, plugins);
// console.log('window.location.href=', window.location.href);
console.log('document.referrer-change-email:=', document.referrer);
console.log('navigator.language:', navigator.language);

const homeUrl = window.location.href;
if (
  homeUrl.indexOf('act=A2') !== -1
  || homeUrl.indexOf('act=A3') !== -1
  || homeUrl.indexOf('act=A5') !== -1
) {
  const lang = sessionStore.get('lang') || 'de';
  sessionStore.remove('auth');
  sessionStore.remove('ciamCode');
  // eslint-disable-next-line max-len
  // window.location.href = `${getCiamDomain()}/v2/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
  // edit by sam 20240619 for uat env
  window.location.href = `${getCiamDomain()}/oidc/logout?client_id=${getCiamClientId()}&post_logout_redirect_uri=${getCiamRedirectUriForLogout()}&lang=${lang}`;
}

if (window.location.href.indexOf('code=') !== -1) {
  const code = decodeURIComponent(
    window.location.href.split('code=')[1].split('&')[0],
  );
  sessionStore.set('ciamCode', code);
  const privacvNotice = sessionStore.get('privacvNotice');
  if (!privacvNotice) {
    sessionStore.set('privacvNotice', 'open');
  }
}

if (window.location.href.indexOf('lang=') !== -1) {
  const lang = window.location.href.split('lang=')[1];
  if (lang === 'en') {
    sessionStore.set('lang', 'en');
  } else if (lang === 'de') {
    sessionStore.set('lang', 'de');
  } else {
    sessionStore.set('lang', 'en');
  }
}

const getSessionLan = sessionStore.get('lang');
if (!getSessionLan) {
  if (navigator.language) {
    const lang = navigator.language;
    if (lang !== 'en') {
      sessionStore.set('lang', 'de');
    } else {
      sessionStore.set('lang', 'en');
    }
  }
}

export const Router = wrapReact(
  () => (
    <OldRouter history={customHistory} className="router">
      <Routes routes={routes} />
    </OldRouter>
  ),
  'util_Router',
  { intl: false },
);
